'use strict';
import clone from 'lodash/clone';
import {getAssetProject, getProject} from '../../app/model/reducers/state';
import {modalOptions as milestonesCreateOptions} from '../../projects/modals/MilestonesCreateController';
import {TaskType} from '../enums/TaskType';


const createTaskTemplate = require('./tasks-create.html');

taskCreateModals.$inject = [
  '$modal',
  '$ngRedux',
];

export function taskCreateModals($modal, $ngRedux) {

  const ctrlConfigs = {};
  ctrlConfigs[TaskType.ASSET] = {
    taskType: TaskType.ASSET,
    modelDomain: 'AssetTaskDomain',
  };
  ctrlConfigs[TaskType.PROJECT] = {
    taskType: TaskType.PROJECT,
    modelDomain: 'TaskDomain',
  };
  ctrlConfigs[TaskType.TEMPLATE] = {
    taskType: TaskType.TEMPLATE,
    modelDomain: 'TaskDomain',
  };

  this.openCreateMilestone = function (project, taskType) {
    return $modal.show({
      ...milestonesCreateOptions,
      locals: {
        project: project,
        taskType: taskType,
      },
    });
  };

  this.openCreateTask = function (milestone, $scope, taskType) {
    const rootState = $ngRedux.getState();
    const options = {
      template: createTaskTemplate,
      controller: 'TasksCreateController',
      animation: 'slide-in-up',
      locals: {
        milestone: milestone || null,
        ctrlConfig: clone(ctrlConfigs[taskType]),
      },
    };
    // options.locals.milestone = milestone || null;
    switch (taskType) {
      case TaskType.ASSET:
        options.locals.project = getAssetProject(rootState);
        break;
      case TaskType.PROJECT:
      case TaskType.TEMPLATE:
        options.locals.project = getProject(rootState);
        break;
    }
    return $modal.show(options);
  };
}



// WEBPACK FOOTER //
// ./src/js/tasks/services/taskCreateModals.js